import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "reactstrap";
import ProductForm from "./ProductForm";

export default function AddProductSections({ sectionData }) {
  const { t } = useTranslation("products");
  const navigate = useNavigate();

  return (
    <div className="AddProductForm content ">
      <Card className="p-4">
        <div className="d-flex mb-4 flex-wrap gap-16 justify-content-between align-items-center ">
          <Button
            onClick={() => navigate(-1)}
            className="btn btn-primary d-flex align-items-center "
          >
            <i
              className="tim-icons icon-minimal-left
                       
                       font-weight-bold mr-2  font-size-xl"
            ></i>
            <span>{t("common.back")}</span>
          </Button>
          <h2 className="text-capitalize mb-0">
            {t("add.title", { name: sectionData.name })}
          </h2>
        </div>

        <ProductForm sectionData={sectionData} />
      </Card>
    </div>
  );
}
